module.exports = __webpack_public_path__ + "fonts/AvenirLTStd-HeavyOblique.1f14920a.woff";